import { LmgService } from "../resource";

const AddressModule = {
  namespaced: true,
  state: {
    provinces: [],
    districts: [],
    subdistricts: [],
  },
  mutations: {
    SET_PROVINCE(state, payload) {
      state.provinces = payload;
    },
    SET_DISTRICT(state, payload) {
      state.districts = payload;
    },
    SET_SUBDISTRICT(state, payload) {
      state.subdistricts = payload;
    },
  },
  actions: {
    async listProvince({ commit, state },payload) {
      try {
        const data = await LmgService.AddressProvinces(payload);
		commit("SET_PROVINCE", data.data.Data == null ?  [] : data.data.Data);
      } catch (err) {
        commit("SET_PROVINCE", []);
      }
    },
	async listDistrict({ commit, state },payload) {
		try {
		  const data = await LmgService.AddressDistrict(payload);
		  commit("SET_DISTRICT", data.data.Data == null ?  [] : data.data.Data);
		} catch (err) {
		  commit("SET_DISTRICT", []);
		}
	  },
	  async listSubDistrict({ commit, state },payload) {
		try {
		  const data = await LmgService.AddressSubDistrict(payload);
		  commit("SET_SUBDISTRICT", data.data.Data == null ?  [] : data.data.Data);
		} catch (err) {
		  commit("SET_SUBDISTRICT", []);
		}
	  },
  },
  getters: {
    getProvince(state) {
      return state.provinces;
    },
    getDistrict(state) {
      return state.districts;
    },
    getSubDistrict(state) {
      return state.subdistricts;
    },
    
  }
};

export default AddressModule;
